module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Hidden-b0b78f3a7d59489a2db233be1e2671c8.svg";